module.exports = __webpack_public_path__ + "static/media/detectDataImage10_2.48f83aec.png";